interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost'; size?:'sm' | 'md' | 'lg'
  children: React.ReactNode
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = 'relative z-[1] uppercase tracking-widest font-semibold transition-all duration-base inline-flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed'
  
  const variants = {
    primary: 'bg-primary text-primary-foreground hover:bg-primary-hover border border-primary hover:shadow-glow',
    secondary: 'bg-transparent text-foreground border border-border hover:border-primary hover:text-primary',
    ghost: 'bg-transparent text-muted-foreground hover:text-foreground border border-transparent hover:border-border',
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-micro',
    md: 'px-6 py-3 text-label',
    lg: 'px-8 py-4 text-label',
  }
  
  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}